import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import flocabularyActions from 'redux/actions/flocabularyActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import PropTypes from 'prop-types'

import styles from './flocabulary_warning_overlay.scss'

class FlocabularyWarningOverlay extends PureComponent {

	constructor(props) {
		super(props)
		this.listeners = {
			onComplete: this.animationCompleted,
		}
	}

	animationCompleted = () => {
		this.props.actions.closeWarningOverlay()
	}

	createAsset() {
		return (
			<Bodymovin
				path='/assets/media/animations/flocabulary_warning_3free.json'
				listeners={this.listeners}
			>
				<div className={styles.animation}></div>
			</Bodymovin>
		)
	}

	render() {

		return (
			<FullOverlay
				assetSource={this.createAsset()}
				assetWidth='80%'
			/>
		)
	}
}

FlocabularyWarningOverlay.propTypes = {
	actions: PropTypes.shape({
		closeWarningOverlay: PropTypes.func.isRequired,
	}).isRequired,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeWarningOverlay: flocabularyActions.flocabularyWarningOverlayFinished,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(FlocabularyWarningOverlay)

export { FlocabularyWarningOverlay }
